<template>
    <el-dialog
            :title="title"
            visible
            width="55%"
            @close="onCancel">
        <el-form ref="form" :model="form" label-width="120px">
            <el-form-item :label="$t('TABLE_HEADER_EXCHANGE_STATUS')" v-if="changeType == 0">
                <el-select v-model="form.status">
                    <el-option
                            v-for="item in statusOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('TABLE_HEADER_DUEDAY')" v-if="changeType == 1">
                <el-date-picker
                        v-model="form.dueDay"
                        value-format="yyyy-MM-dd"
                        type="date">
                </el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('TABLE_HEADER_KPUSER')" v-if="changeType == 2">
                <el-select v-model="form.chargeUser">
                    <el-option
                            v-for="item in kpmgUserList"
                            :key="item.id"
                            :label="item.userName"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
                <el-button @click="onCancel"
                           class="cancel-btn">{{$t('btn_cancel')}}</el-button>
                <el-button type="primary"
                           :loading="batchChangeLoading"
                           @click="onConfirm"
                           class="wl-green">{{$t('btn_save')}}</el-button>
          </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "batch-change",
        data(){
            return {
               form: {
                   status: '',
                   dueDay: '',
                   chargeUser: ''
               }
            }
        },
        methods: {
            onConfirm(){
                if(this.changeType == 0){
                    if (['2', '4'].includes(this.form.status)) {
                        this.$confirm(this.$t(`confirm_not_editble_${this.form.status}`), this.$t('COMMON_TIP'), {
                            showConfirmButton: true,
                            confirmButtonText: this.$t('btn_confirm'),
                            confirmButtonClass: 'wl-green',

                            showCancelButton: true,
                            cancelButtonText: this.$t('comment_reSet'),
                            cancelButtonClass: 'cancel-btn',

                            closeOnClickModal: false,
                            dangerouslyUseHTMLString: true,
                            type: 'warning'
                        }).then(async () => {
                            this.onChange({status: this.form.status})
                        })
                    } else {
                        this.onChange({status: this.form.status})
                    }
                } else if(this.changeType == 1){
                    this.onChange({dueDay: this.form.dueDay})
                } else{
                    this.onChange({chargeUser: this.form.chargeUser})
                }
            }
        },
        props: {
            title: {
                type: String,
                default: ''
            },
            changeType: {
                type: Number,
                default: 0
            },
            statusOptions: {
                type: Array,
                default: []
            },
            kpmgUserList: {
                type: Array,
                default: []
            },
            onCancel: {
                type: Function,
                default: () => {}
            },
            onChange: {
                type: Function,
                default: () => {}
            },
            batchChangeLoading: {
                type: Boolean,
                default: false
            },
        }
    }
</script>

<style scoped>

</style>